/**
 * NetworkPaymentSystem entity class
 */

/**
 * NetworkPaymentSystemFactory
 * returns NetworkPaymentSystem entity class
 *
 * @class NetworkPaymentSystemFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.NetworkPaymentSystem} class
 *
 * @ngdoc factory
 * @name mwApp.factory:NetworkPaymentSystemFactory
 */
/* @ngInject */
export default function NetworkPaymentSystemFactory ($http, alertLiteSvc, PaymentSystem) {
  /* === NetworkPaymentSystem class === */

  /**
   * NetworkPaymentSystem model
   *
   * @class NetworkPaymentSystem
   * @classdesc NetworkPaymentSystem model
   * @memberof models
   * @see models
   * @extends models.PaymentSystem
   * @param {Object} [object] - initial object, containing NetworkPaymentSystem entity fields
   * @return {models.NetworkPaymentSystem} NetworkPaymentSystem entity
   */
  function NetworkPaymentSystem () {
    var obj = PaymentSystem.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  NetworkPaymentSystem.prototype = Object.create(PaymentSystem.prototype)
  NetworkPaymentSystem.prototype.constructor = NetworkPaymentSystem

  /* === NetworkPaymentSystem instance methods & fields === */

  Object.assign(NetworkPaymentSystem.prototype, {

    /**
     * url template
     *
     * @memberof models.NetworkPaymentSystem#
     * @type {String}
     */
    _urlTemplate: 'api/networks/{{::network && network.id ? network.id : $network.id}}/paymentsystems/{{::id}}', // use field `$network`, set it manually

    /**
     * Set NetworkPaymentSystem to use system default (or not use), performing PATCH request to the server
     *
     * @memberof models.PaymentSystem#
     * @return {Promise} promise
     */
    _systemDefault: function () {
      return $http.patch(this._url, this.useSystemDefault ? '"USE_SYSTEM_DEFAULT"' : '"NOT_USE_SYSTEM_DEFAULT"')
        .then(
          response => {
            this._weakCopy(response.data)
            return response
          }
        ).catch(
          rejection => {
            this.useSystemDefault = !this.useSystemDefault
            return alertLiteSvc.alertError(rejection)
          }
        )
    }

  })

  /* === NetworkPaymentSystem static methods & fields === */

  // copy all static methods from PaymentSystem class
  Object.assign(NetworkPaymentSystem, PaymentSystem)
  NetworkPaymentSystem._name = 'NetworkPaymentSystem'
  NetworkPaymentSystem.init()

  // permissions
  NetworkPaymentSystem.access = {
    view: 'viewNetworkPayment',
    // create: '',
    edit: 'editNetworkPayment'
    // delete: ''
  }

  return NetworkPaymentSystem
}
